/* eslint-disable prettier/prettier */
import { isDateGreaterThan, isDateLessThan, isDateWithinRange } from "../Utils/DateUtils";
export const getMatchesForDateSelection = (refinerGroup, results) => {
    return results.filter((result) => {
        return isDateRangeMatch(refinerGroup, result);
    });
};
/**
 * Does result match for date range refiner
 */
export const isDateRangeMatch = (refinerGroup, result) => {
    if (!refinerGroup.dateRange) {
        return false;
    }
    if (result[refinerGroup.path] === undefined || result[refinerGroup.path] === null) {
        return false;
    }
    //Date within range
    if (refinerGroup.dateRange.fromDate && refinerGroup.dateRange.toDate) {
        return isDateWithinRange(result[refinerGroup.path], refinerGroup.dateRange?.fromDate, refinerGroup.dateRange?.toDate, false);
    }
    //All dates > From Date
    if (refinerGroup.dateRange.fromDate && !refinerGroup.dateRange.toDate) {
        return isDateGreaterThan(result[refinerGroup.path], refinerGroup.dateRange.fromDate, false);
    }
    //All dates < To Date
    if (refinerGroup.dateRange.toDate && !refinerGroup.dateRange.fromDate) {
        return isDateLessThan(result[refinerGroup.path], refinerGroup.dateRange.toDate, false);
    }
    return false;
};
/**
 * Updates refiner based on date range matches
 */
export const updateDateRangeRefiner = ({ group, results }) => {
    let newFilteredResults = null;
    if (group.dateRange?.fromDate || group.dateRange?.toDate) {
        const matches = getMatchesForDateSelection(group, results);
        if (newFilteredResults === null) {
            newFilteredResults = [];
        }
        newFilteredResults.push(...matches);
    }
    return newFilteredResults;
};
